'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = require('react-router');

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _ = require('..');

var _2 = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventDate = function (_Component) {
  (0, _inherits3.default)(EventDate, _Component);

  function EventDate(props) {
    (0, _classCallCheck3.default)(this, EventDate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EventDate.__proto__ || (0, _getPrototypeOf2.default)(EventDate)).call(this, props));

    _moment2.default.locale(_this.props.locale);

    var selectedDate = _this.props.selectedDate;

    if (!selectedDate) {
      selectedDate = _this.props.dates[0];
    }

    _this.state = {
      showMoreDatesPopover: false,
      selectedDate: selectedDate
    };
    return _this;
  }

  (0, _createClass3.default)(EventDate, [{
    key: 'getMoreDatesList',
    value: function getMoreDatesList() {
      var _this2 = this;

      var _props = this.props,
          dates = _props.dates,
          dateFormat = _props.dateFormat,
          timeFormat = _props.timeFormat,
          withoutMinutes = _props.timeFormatWithoutMinutes;


      return _react2.default.createElement(
        'ul',
        { className: 'moreDates' },
        dates.map(function (date) {
          var formattedDate = (0, _moment2.default)(date.start_date).format(dateFormat);
          var formattedTime = (0, _moment2.default)(date.start_date).formatTime(timeFormat, withoutMinutes);
          var pathname = _this2.props.pathName;
          var selected = _this2.state.selectedDate.id === date.id;
          var props = selected ? { className: 'selected' } : {};
          var query = { date: (0, _moment2.default)(date.start_date).format('YYYY-MM-DD_HH-mm-ss') };
          return _react2.default.createElement(
            'li',
            (0, _extends3.default)({ key: date.id }, props),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: { pathname: pathname, query: query }, onClick: _this2.handleDateSelection.bind(_this2, date) },
              selected && _react2.default.createElement(_2.Icon, { name: 'checkmark' }),
              formattedDate + ' \u2013 ' + formattedTime
            )
          );
        })
      );
    }
  }, {
    key: 'handleDateSelection',
    value: function handleDateSelection(selectedDate) {
      return this.setState({
        selectedDate: selectedDate,
        showMoreDatesPopover: false
      });
    }
  }, {
    key: 'toggleMoreDates',
    value: function toggleMoreDates() {
      return this.setState({
        showMoreDatesPopover: !this.state.showMoreDatesPopover
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          dates = _props2.dates,
          dateFormat = _props2.dateFormat,
          shortDateFormat = _props2.shortDateFormat,
          timeFormat = _props2.timeFormat,
          timeFormatWithoutMinutes = _props2.timeFormatWithoutMinutes;
      var selectedDate = this.state.selectedDate;

      var momentDate = (0, _moment2.default)(selectedDate.start_date);
      var formattedDate = momentDate.format(dateFormat);
      var formattedStartTime = momentDate.formatTime(timeFormat, timeFormatWithoutMinutes);
      var startDate = (0, _moment2.default)(dates[0].start_date).format(shortDateFormat);
      var endDate = (0, _moment2.default)(dates[dates.length - 1].start_date).format(shortDateFormat);
      var otherDatesCount = dates.length - 1;
      var formattedTime = void 0;

      if (selectedDate.duration > 0) {
        var endTime = momentDate.clone().add(selectedDate.duration, 'seconds');
        var formattedEndTime = endTime.formatTime(timeFormat, timeFormatWithoutMinutes);
        formattedTime = formattedStartTime + ' ' + (0, _i18n2.default)('time.rangeDelimiter') + ' ' + formattedEndTime;
      } else {
        formattedTime = formattedStartTime;
      }

      return _react2.default.createElement(
        'div',
        { className: 'EventDate' },
        _react2.default.createElement(
          'div',
          { className: 'date' },
          formattedDate
        ),
        _react2.default.createElement(
          'div',
          { className: 'time' },
          formattedTime
        ),
        dates.length > 1 && _react2.default.createElement(
          'div',
          { className: 'otherDates' },
          _react2.default.createElement(
            _2.Popover,
            {
              visible: this.state.showMoreDatesPopover,
              dropdownView: this.getMoreDatesList(),
              clickOverlay: this.toggleMoreDates.bind(this)
            },
            _react2.default.createElement(
              'span',
              { className: 'count', onClick: this.toggleMoreDates.bind(this) },
              _react2.default.createElement(_2.Icon, { name: 'multipleDates' }),
              _react2.default.createElement(
                'span',
                null,
                otherDatesCount,
                ' ',
                (0, _i18n2.default)('otherDates', otherDatesCount)
              ),
              _react2.default.createElement(_2.Icon, { name: 'chevronDown' })
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'range' },
            (0, _i18n2.default)('date.from'),
            ' ',
            startDate,
            ' ',
            (0, _i18n2.default)('date.to'),
            ' ',
            endDate
          )
        )
      );
    }
  }]);
  return EventDate;
}(_react.Component);

EventDate.propTypes = {
  /**
   * Array of dates as returned by the Caligram API.
   */
  dates: _propTypes2.default.array.isRequired,
  /**
   * [Moment](http://momentjs.com/docs/#/displaying/) format string used to display the date.
   */
  dateFormat: _propTypes2.default.string,
  /**
   * [Moment](https://momentjs.com/docs/#/i18n/) locale string
   */
  locale: _propTypes2.default.string,
  /**
   * The relative path of the event. Used for inner navigation.
   */
  pathName: _propTypes2.default.string.isRequired,
  /**
   * ID of the currently selected date.
   */
  selectedDate: _propTypes2.default.any,
  /**
   * [Moment](http://momentjs.com/docs/#/displaying/) format string used to display the date range.
   */
  shortDateFormat: _propTypes2.default.string,
  /**
   * [Moment](http://momentjs.com/docs/#/displaying/) format string used to display the time.
   */
  timeFormat: _propTypes2.default.string,
  /**
   * Time format to use when there are zero minutes.
   */
  timeFormatWithoutMinutes: _propTypes2.default.string
};
EventDate.defaultProps = {
  dateFormat: 'dddd D MMMM YYYY',
  locale: _.CaligramReact.config().locale,
  shortDateFormat: 'Do MMMM',
  timeFormat: 'H [h] mm',
  timeFormatWithoutMinutes: 'H [h]'
};
exports.default = EventDate;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventDate.js
// module id = 261
// module chunks = 0